import PropTypes from "prop-types";

import { Row, Col, CustomContainer } from "components/atoms/DependencyHelper";
import PageHeading from "components/atoms/pageHeading/PageHeading";
import BreadCrumb from "components/atoms/breadCrumb/BreadCrumb";

import { formatBreadCrumb } from "utils/helperServices";

import { breadcrumbGenerator } from "services/breadcrumbService"

import styles from "./DealDetailsHeader.module.scss";

const DealDetailsHeader = ({ productName }) => {

  return (
    <CustomContainer className={styles["product-details-header-container"]}>
      <BreadCrumb
        list={formatBreadCrumb(breadcrumbGenerator().dealdetails)}
        title={productName}
        replacePageTitle={true}
      ></BreadCrumb>

      <Row>
        <Col xs={12}>
          <PageHeading
            text={productName}
            variant="product-details-heading"
            className="my-l"
          />
        </Col>
      </Row>
    </CustomContainer>
  );
};

DealDetailsHeader.defaultProps = {
  productName: ""
};

DealDetailsHeader.propTypes = {
  productName: PropTypes.string,
};

export default DealDetailsHeader;
